import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { FilterDropDownIcon } from './svgIcon';

function FilterDropDown(props) {
  const {
    filter,
    selectedFilter,
    setFilter,
  } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState('Select');
  const dropdownRef = useRef(null);
  function calculateDates(option) {
    const today = new Date(); // Get today's date
    let start;
    let end;

    // Reset the time to midnight for "start" date
    const resetTime = (date) => {
      const newDate = new Date(date);
      newDate.setHours(0, 0, 0, 0); // Set to midnight (00:00:00)
      return newDate;
    };

    // Reset the time to the end of the day (23:59:59.999) for "end" date
    const setEndOfDay = (date) => {
      const newDate = new Date(date);
      newDate.setHours(23, 59, 59, 999); // Set to end of day (23:59:59.999)
      return newDate;
    };

    // Utility to format date as 'dd-mm-yyyy'
    const formatDate = (date) => {
      if (!date) return null;
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is zero-indexed
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    };

    switch (option) {
      case 'Today': {
        start = resetTime(today);
        end = setEndOfDay(today);
        break;
      }

      case 'Yesterday': {
        // Create a new date object to avoid mutating the original "today"
        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);
        start = resetTime(yesterday);
        end = setEndOfDay(new Date(today));
        break;
      }

      case 'Last Week': {
        const sunday = new Date(today);
        // const dayOfWeek = today.getDay();
        sunday.setDate(today.getDate() - 6); // Go to the previous Sunday

        start = resetTime(sunday); // Sunday of last week
        end = setEndOfDay(new Date(today)); // Saturday of last week
        break;
      }

      case 'Last 30days': {
        // Create a new date object to avoid mutating "today"
        const thirtyDaysAgo = new Date(today);
        thirtyDaysAgo.setDate(today.getDate() - 30);
        start = resetTime(thirtyDaysAgo);
        end = setEndOfDay(new Date(today));
        break;
      }

      case 'Last 60days': {
        // Create a new date object to avoid mutating "today"
        const sixtyDaysAgo = new Date(today);
        sixtyDaysAgo.setDate(today.getDate() - 60);
        start = resetTime(sixtyDaysAgo);
        end = setEndOfDay(new Date(today));
        break;
      }

      case 'Last 90days': {
        // Create a new date object to avoid mutating "today"
        const ninetyDaysAgo = new Date(today);
        ninetyDaysAgo.setDate(today.getDate() - 90);
        start = resetTime(ninetyDaysAgo);
        end = setEndOfDay(new Date(today));
        break;
      }

      default:
        start = null;
        end = null;
        break;
    }

    return {
      startDate: formatDate(start),
      endDate: formatDate(end),
    };
  }

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  // const handleDateClick = (date) => {
  //   if (date !== selected) {
  //     setSelected(date);
  //     const dates = calculateDates(date);
  //     const object1 = { filterBy: selectedFilter, result: dates?.startDate, key: 'startDate' };
  //     const object2 = { filterBy: selectedFilter, result: dates?.endDate, key: 'endDate' };
  //     setFilter([...filter, object1, object2]);
  //   }
  // };

  const handleDateClick = (date) => {
    if (date !== selected) {
      setSelected(date);
      const dates = calculateDates(date);

      // Remove existing date filters for the current selectedFilter
      const updatedFilter = filter?.filter(
        (f) => !(f.filterBy === selectedFilter && (f.key === 'startDate' || f.key === 'endDate')),
      );

      const object1 = { filterBy: selectedFilter, result: dates?.startDate, key: 'startDate' };
      const object2 = { filterBy: selectedFilter, result: dates?.endDate, key: 'endDate' };

      setFilter([...updatedFilter, object1, object2]);
    }
  };

  const filterDate = ['Today', 'Yesterday', 'Last Week', 'Last 30days', 'Last 60days', 'Last 90days'];
  return (
    <div className="Filter-drop-down" ref={dropdownRef}>
      <div className="dropdown-icon" onClick={handleClick} role="none">
        <span>{selected}</span>
        <FilterDropDownIcon />
      </div>
      {isOpen && (
        <div className="dropdown-content">
          <ul>
            {filterDate?.map((date) => (
              <li role="none" key={date} onClick={() => handleDateClick(date)}>{date}</li>
            ))}
            {/* <li>Today</li>
            <li>Yesterday</li>
            <li>Last Week</li>
            <li>Last 30days</li>
            <li>Last 60days</li>
            <li>Last 90days</li> */}
          </ul>
        </div>
      )}
    </div>
  );
}

FilterDropDown.propTypes = {
  setFilter: PropTypes.func.isRequired,
  filter: PropTypes.arrayOf.isRequired,
  selectedFilter: PropTypes.string.isRequired,
};

export default FilterDropDown;
